var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTraffic = function SvgTraffic(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-4893441a-307c-4696-8fc0-64933bfe66ab{opacity:.7;}.uuid-fec7506b-abce-40e4-a657-805663f0417c{clip-path:url(#uuid-f9078004-fbcb-4666-a3d6-d4594254fcdb);}.uuid-9d49e35a-f589-4ca5-ae54-2aa9029e47b8{clip-path:url(#uuid-b73bbbee-0c8a-46d0-ab93-e7bdc25fb2d3);}.uuid-4fa2b3a8-a706-4f48-8b75-8f9bfb2194c7{fill:#072120;}.uuid-4fa2b3a8-a706-4f48-8b75-8f9bfb2194c7,.uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59,.uuid-5da40424-fbf9-4a7e-a07e-948047f13adb,.uuid-ae5918d3-dce2-4125-883c-0cb27043d360,.uuid-df733cc8-c739-4db4-be2e-12229e6e8a6c{stroke-width:0px;}.uuid-49dc2939-350f-41ef-9075-ce0cfff27bae{mask:url(#uuid-d7625080-ee90-4cf4-90c2-4bab2fa5c540);}.uuid-fa9fe97c-8f0e-41ba-a784-bfb6a8d98846{clip-path:url(#uuid-a5ccf27a-0542-4bce-969d-aa7fa7e9bebd);}.uuid-aa9e77d5-0505-4487-ad43-d166f06deee0{clip-path:url(#uuid-f955b1c0-b22b-40a8-9ddb-e9dabf43c594);}.uuid-cb1c19d2-cf83-4c1f-b525-18989de82899,.uuid-3d8c8e94-0d86-4b2e-b3fe-1ec05e396038{isolation:isolate;}.uuid-63821476-b24f-41f3-94c6-98c8e7b53a1d{clip-path:url(#uuid-6ed117e8-a523-4d9b-9b3d-53eb4e4618f6);}.uuid-8ab62fd1-3f55-43ed-bb47-ebadb9dea30c{clip-path:url(#uuid-01336304-25ee-41fe-bf29-ad54fdf00a51);}.uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59{fill:none;}.uuid-d2c74803-5a73-4dfb-9f3b-6003b3c79bfc{opacity:.7;}.uuid-5da40424-fbf9-4a7e-a07e-948047f13adb{fill:#3e4959;}.uuid-3d8c8e94-0d86-4b2e-b3fe-1ec05e396038{mix-blend-mode:screen;}.uuid-3bd3fefa-6ec5-47af-bc65-aa29bf3add25{clip-path:url(#uuid-98087231-24b5-4afd-aeac-5524eaa7511f);}.uuid-ae5918d3-dce2-4125-883c-0cb27043d360{fill:#d8d9d9;}.uuid-005d9c33-cb02-4d37-a7ac-be4360d6ddd8{clip-path:url(#uuid-d11ba084-85d3-49bf-a99b-b6c6a66e3356);}.uuid-83f95144-62a6-4403-ade9-f67f8381b8cd{opacity:.6;}.uuid-df733cc8-c739-4db4-be2e-12229e6e8a6c{fill:#fff;opacity:.06;}.uuid-ea056e6f-e617-4897-9656-5ce8615335f2{clip-path:url(#uuid-48dd424c-80a8-459b-b2f5-95a4471982de);}.uuid-f0628455-0c01-45a7-8963-f0aef002acc2{clip-path:url(#uuid-b594be48-2a7d-4bfe-ab03-54105cdc54f8);}.uuid-0cb6bc9f-cf3f-4ace-b7c5-867da1f89c87{clip-path:url(#uuid-7e770673-cc0f-452b-ac9f-eabcbfb69881);}"), /*#__PURE__*/React.createElement("mask", {
    id: "uuid-d7625080-ee90-4cf4-90c2-4bab2fa5c540",
    x: -671.1,
    y: -795.81,
    width: 1956.59,
    height: 1811.34,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-ae5918d3-dce2-4125-883c-0cb27043d360",
    x: -147.05,
    y: -157.33,
    width: 1432.47,
    height: 1172.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-01336304-25ee-41fe-bf29-ad54fdf00a51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    d: "M0-41.63h600v-95.75c0-11.02-8.93-19.95-19.95-19.95H19.95c-11.02,0-19.95,8.93-19.95,19.95V-41.63Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-a5ccf27a-0542-4bce-969d-aa7fa7e9bebd"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    x: -147.05,
    y: -157.33,
    width: 1432.54,
    height: 1172.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-f9078004-fbcb-4666-a3d6-d4594254fcdb"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    x: -147.05,
    y: -157.33,
    width: 1432.54,
    height: 1172.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-b73bbbee-0c8a-46d0-ab93-e7bdc25fb2d3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    cx: -127.56,
    cy: -342.02,
    r: 382.72
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-48dd424c-80a8-459b-b2f5-95a4471982de"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    x: -147.05,
    y: -157.33,
    width: 1432.54,
    height: 1172.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-7e770673-cc0f-452b-ac9f-eabcbfb69881"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    cx: -82.85,
    cy: -242.38,
    r: 515.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-d11ba084-85d3-49bf-a99b-b6c6a66e3356"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    x: -147.05,
    y: -157.33,
    width: 1432.54,
    height: 1172.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-f955b1c0-b22b-40a8-9ddb-e9dabf43c594"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    cx: -20.33,
    cy: -145.04,
    r: 647.99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-b594be48-2a7d-4bfe-ab03-54105cdc54f8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    x: -61.2,
    y: -10.16,
    width: 69.5,
    height: 69.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-6ed117e8-a523-4d9b-9b3d-53eb4e4618f6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    x: -147.05,
    y: -157.33,
    width: 1432.54,
    height: 1172.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-98087231-24b5-4afd-aeac-5524eaa7511f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-f269c8c4-2a31-4542-8c60-ad9da4884f59",
    x: -324.81,
    y: -348.79,
    width: 1023.75,
    height: 1051.89
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "uuid-cb1c19d2-cf83-4c1f-b525-18989de82899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-0aa55487-2f7d-4dad-a9b0-681585e63701"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-4fa2b3a8-a706-4f48-8b75-8f9bfb2194c7",
    d: "M8.72,9c0,.66-.42,1.27-1.06,1.52-.64.25-1.38.11-1.87-.36-.49-.47-.64-1.18-.37-1.79.27-.62.89-1.02,1.59-1.02.95,0,1.72.74,1.72,1.65ZM7,2.42c-.7,0-1.32.4-1.59,1.02-.27.61-.12,1.32.37,1.79.49.47,1.23.61,1.87.36.64-.25,1.06-.85,1.06-1.52,0-.91-.77-1.65-1.72-1.65ZM7,12.29c-.7,0-1.32.4-1.59,1.02-.27.61-.12,1.32.37,1.79.49.47,1.23.61,1.87.36.64-.25,1.06-.85,1.06-1.52,0-.91-.77-1.65-1.72-1.65ZM11.09,10.65v1.64h1.93c.47,0,.86.37.86.82,0,1.36-1.15,2.47-2.58,2.47h-.21c0,.6-.25,1.18-.69,1.6-.44.42-1.05.66-1.67.66h-3.44c-1.31,0-2.37-1.01-2.37-2.26h-.21C1.28,15.58.12,14.48.12,13.11c0-.45.38-.82.86-.82h1.93v-1.64h-.21C1.28,10.65.12,9.54.12,8.18c0-.45.38-.82.86-.82h1.93v-1.65h-.21C1.28,5.71.12,4.61.12,3.24c0-.22.09-.43.25-.58.16-.15.38-.24.61-.24h1.93C2.91,1.17,3.97.16,5.28.16h3.44c.63,0,1.23.24,1.67.66.44.42.69,1,.69,1.6h1.93c.23,0,.45.08.61.24.16.16.25.37.25.58,0,1.36-1.15,2.47-2.58,2.47h-.21v1.65h1.93c.48,0,.86.37.86.82,0,1.36-1.15,2.47-2.58,2.47h-.21ZM9.77,2.42c0-.56-.47-1.02-1.05-1.03h-3.44c-.59,0-1.05.47-1.05,1.03v13.16c0,.57.48,1.03,1.07,1.03h3.44c.58-.02,1.04-.47,1.04-1.03V2.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-ea0c6a4f-b7e8-40e4-9933-d3ad2579cc48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-49dc2939-350f-41ef-9075-ce0cfff27bae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-5738647e-7515-4d45-b4b1-26bfc0b3601f",
    className: "uuid-4893441a-307c-4696-8fc0-64933bfe66ab"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-8ab62fd1-3f55-43ed-bb47-ebadb9dea30c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-d2c74803-5a73-4dfb-9f3b-6003b3c79bfc"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-fa9fe97c-8f0e-41ba-a784-bfb6a8d98846"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-83f95144-62a6-4403-ade9-f67f8381b8cd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-fec7506b-abce-40e4-a657-805663f0417c"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-df733cc8-c739-4db4-be2e-12229e6e8a6c",
    cx: -127.56,
    cy: -342.02,
    r: 382.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "uuid-9d49e35a-f589-4ca5-ae54-2aa9029e47b8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5da40424-fbf9-4a7e-a07e-948047f13adb",
    d: "M-127.56-721.96c-209.84,0-379.94,170.11-379.94,379.94h-5.56c0-212.91,172.6-385.51,385.51-385.51v5.56ZM252.38-342.02c0-209.84-170.11-379.94-379.94-379.94v-5.56c212.91,0,385.51,172.6,385.51,385.51h-5.56ZM-127.56,37.92c209.84,0,379.94-170.11,379.94-379.94h5.56c0,212.91-172.6,385.51-385.51,385.51v-5.56ZM-507.51-342.02c0,209.84,170.11,379.94,379.94,379.94v5.56c-212.91,0-385.51-172.6-385.51-385.51h5.56Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "uuid-83f95144-62a6-4403-ade9-f67f8381b8cd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-ea056e6f-e617-4897-9656-5ce8615335f2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-df733cc8-c739-4db4-be2e-12229e6e8a6c",
    cx: -82.85,
    cy: -242.38,
    r: 515.58
  }), /*#__PURE__*/React.createElement("g", {
    className: "uuid-0cb6bc9f-cf3f-4ace-b7c5-867da1f89c87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5da40424-fbf9-4a7e-a07e-948047f13adb",
    d: "M-82.85-755.18c-283.21,0-512.8,229.59-512.8,512.8h-5.56c0-286.28,232.08-518.36,518.36-518.36v5.56ZM429.94-242.38c0-283.21-229.59-512.8-512.8-512.8v-5.56c286.28,0,518.36,232.08,518.36,518.36h-5.56ZM-82.85,270.42c283.21,0,512.8-229.59,512.8-512.8h5.56c0,286.28-232.08,518.36-518.36,518.36v-5.56ZM-595.65-242.38c0,283.21,229.59,512.8,512.8,512.8v5.56c-286.28,0-518.36-232.08-518.36-518.36h5.56Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "uuid-83f95144-62a6-4403-ade9-f67f8381b8cd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-005d9c33-cb02-4d37-a7ac-be4360d6ddd8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-df733cc8-c739-4db4-be2e-12229e6e8a6c",
    cx: -20.33,
    cy: -145.04,
    r: 647.99
  }), /*#__PURE__*/React.createElement("g", {
    className: "uuid-aa9e77d5-0505-4487-ad43-d166f06deee0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5da40424-fbf9-4a7e-a07e-948047f13adb",
    d: "M-20.33-790.25c-356.34,0-645.21,288.87-645.21,645.21h-5.56c0-359.41,291.36-650.77,650.77-650.77v5.56ZM624.88-145.04c0-356.34-288.87-645.21-645.21-645.21v-5.56c359.41,0,650.77,291.36,650.77,650.77h-5.56ZM-20.33,500.16c356.34,0,645.21-288.87,645.21-645.21h5.56c0,359.41-291.36,650.77-650.77,650.77v-5.56ZM-665.54-145.04c0,356.34,288.87,645.21,645.21,645.21v5.56c-359.41,0-650.77-291.36-650.77-650.77h5.56Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "uuid-f0628455-0c01-45a7-8963-f0aef002acc2"
  }, /*#__PURE__*/React.createElement("image", {
    width: 128,
    height: 128,
    transform: "translate(-61.2 -10.16) scale(.54)",
    xlinkHref: "Icon-traffic-1.png"
  })), /*#__PURE__*/React.createElement("g", {
    className: "uuid-3d8c8e94-0d86-4b2e-b3fe-1ec05e396038"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-63821476-b24f-41f3-94c6-98c8e7b53a1d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-3bd3fefa-6ec5-47af-bc65-aa29bf3add25"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1885,
    height: 1937,
    transform: "translate(-324.81 -348.79) scale(.54)",
    xlinkHref: "Icon-traffic-2.png"
  })))))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTraffic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "traffic.0556b6abb9ff518adb767a71bcd1e010.svg";